export const MAX_DESC_LENGTH = 15000;
export const PERSISTENT_STORAGE_KEY = "SUNDAE_SWAP_PERSISTENT_STORAGE_KEY";
//# sourceMappingURL=constants.js.map